import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDibLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48.8 34",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M14.5,0h-1.5c-1.3,0-2.4,1.1-2.4,2.4V13c0,0-4,0-5.1,0C4.3,13,0,14.2,0,19v9.5C0.1,33,4.3,34,5.4,34c1.1,0,2.5,0,3.4,0c0.9,0,2.4,0,3.2,0c0.8,0,2,0,3,0c1,0,1.8-1.1,1.8-2.4V2.4C16.8,1.1,15.8,0,14.5,0z M10.9,23.6v4.3c0,0.8-0.5,1.5-1.6,1.5H6.8c-1.3,0-2.2-1.1-2.2-2.4v-3.4v-0.1v-3.4c0-1.3,0.9-2.4,2.2-2.4h2.5c1.1,0,1.6,0.7,1.6,1.5V23.6z" }),
			/* @__PURE__ */ _jsx("path", { d: "M27.5,31.6c0,1.3-1.1,2.4-2.4,2.4h-1.8c-1.3,0-2.1-1.1-2.1-2.4v-16c0-1.3,0.8-2.4,2.1-2.4h1.8c1.3,0,2.4,1.1,2.4,2.4V31.6z" }),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF8E42",
				d: "M27.5,9.1c0,1.3-0.9,2.4-2.2,2.4h-2c-1.3,0-2.1-1.1-2.1-2.4V2.4C21.2,1.1,22,0,23.3,0h2c1.3,0,2.2,1.1,2.2,2.4V9.1z"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M43.4,13c-1.1,0-5.1,0-5.1,0V2.4c0-1.3-1.1-2.4-2.4-2.4h-1.5C33.1,0,32,1.1,32,2.4v29.2c0,1.3,0.8,2.4,1.8,2.4c1,0,2.2,0,3,0c0.8,0,2.3,0,3.2,0c0.9,0,2.3,0,3.4,0c1.1,0,5.3-1,5.4-5.5V19C48.8,14.2,44.5,13,43.4,13zM44.2,23.6v3.4c0,1.3-0.9,2.4-2.2,2.4h-2.5c-1.1,0-1.6-0.7-1.6-1.5v-4.2v-0.1v-4.2c0-0.8,0.5-1.5,1.6-1.5H42c1.3,0,2.2,1.1,2.2,2.4V23.6z" })
		]
	})
});
export default SvgDibLogo;
